import type { HTMLAttributes, ReactNode } from "react";
import { textColors, colorsSortedNoBlack as allColors } from "@/shared/forms/ColorPicker";
import type { CalProject } from "./InnerCalendar";

interface CalendarJobBoxProps extends HTMLAttributes<HTMLDivElement> {
  projectId: number;
  zoom: number;
  booked: boolean;
  hide?: number;
}

export default function CalendarJobBox({ projectId, zoom, booked, hide = 0, className = "", style, ...props }: CalendarJobBoxProps) {
  const color = allColors[projectId % allColors.length];
  return (
    <div
      {...props}
      className={"resourceOrder" + (hide > 0 ? " moveX" + hide : "") + (booked ? " resourceBooking" : "") + (className ? " " + className : "")}
      style={{ ...(zoom < 40 ? { backgroundColor: color, color: textColors[color], opacity: booked ? 1 : 0.6 } : {}), ...style }}
    />
  );
}

export function CalendarProjectName({ project, children }: { project: Pick<CalProject, "name" | "number">; children?: ReactNode }) {
  return <div className="name">{project.name + " (" + project.number + ")"}{children}</div>;
}
